import { Component, OnInit, ViewChild, ElementRef, Inject, Renderer2, Directive } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/languageService.service';
import { LoginControllerApi } from 'src/app/api/loginController.api';
import { Toastr } from 'src/app/services/toastrService';
import { DashboardControllerApi } from 'src/app/api/Dashboard_Controller.api';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  layoutDir = "rtl"
  lang: string;
  imgSrc: string;
  message: any;
  fullName: any;
  userId: string | null;
  email: any;
  mobile: any;


  constructor(
    @Inject(DOCUMENT) private document: Document ,
    private renderer: Renderer2,
    private router: Router,
    public languageService: LanguageService,
    public translate: TranslateService,
    public loginController: LoginControllerApi,
    private toast:Toastr,
    private dashboardController: DashboardControllerApi
  ) { }

  ngOnInit(): void {

    
    this.userId= localStorage.getItem('adminUserId');
    this.getUserInfo();

    
    let lang = localStorage.getItem('lang');
    if (lang == 'ar') {
      this.imgSrc = "assets/images/flags/ar.svg"
      this.lang = "Arabic"
      this.languageService.languageState.next('ar');
    }
    if (lang == 'en') {
      this.imgSrc = "assets/images/flags/us.svg"
      this.lang = "English"
      this.languageService.languageState.next('en');
    }
  }

  changeLanguage(lang: string) {
    this.translate.use(lang.toString())
    localStorage.setItem('currentLang', lang);
    if (lang == 'ar') {
      this.imgSrc = "assets/images/flags/ar.svg"
      this.lang = "Arabic"
      this.languageService.languageState.next('ar');
    }
    if (lang == 'en') {
      this.imgSrc = "assets/images/flags/us.svg"
      this.lang = "English"
      this.languageService.languageState.next('en');
    }



  }
  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');


  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    let body={

    }
    e.preventDefault();
    this.loginController.logout(body).subscribe((response:any)=> {
      console.log(response);
      localStorage.removeItem('token-admin');
    localStorage.removeItem('isLoggedin');

    this.message=response.body.message;
    // this.toast.showInfo(this.message)
    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth-admin/login']);
    }
  })
  }


  getUserInfo(){
    this.dashboardController.getUserInfo(this.userId).subscribe((response: any) => {
      this.fullName=response.body.fullName;
      this.email=response.body.email;
      this.mobile=response.body.mobile;
    },)
  }
  


}
